import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { colors, fonts } from '../../styles/theme';

const DefaultIndicator = styled('span')`
  font-family: ${fonts.sans.family};
  font-weight: 500;
  display: inline-block;
  border-radius: 2px;
  color: ${colors.white};
  background: ${colors.grey.primary};
  border-color: ${colors.grey.primary};
  font-size: 10px;
  line-height: 15px;
  letter-spacing: 0.05em;
  padding: 0 3px 0 4px;
  top: -1px;
  position: relative;
  text-transform: uppercase;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: none;
`;

const Indicator = ({ className, text }) => (
  <DefaultIndicator className={className}>{text}</DefaultIndicator>
);

Indicator.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Indicator.defaultProps = {
  className: '',
};

const PositiveIndicator = styled(Indicator)`
  background: ${colors.green.primary};
  border-color: ${colors.green.primary};
`;

const NegativeIndicator = styled(Indicator)`
  background: ${colors.red.primary};
  border-color: ${colors.red.primary};
`;

const NoticeIndicator = styled(Indicator)`
  color: ${colors.black};
  background: ${colors.yellow.primary};
  border-color: ${colors.yellow.primary};
`;

const ProgressIndicator = styled(Indicator)`
  background: ${colors.orange.primary};
  border-color: ${colors.orange.primary};
`;

const InversePositiveIndicator = styled(Indicator)`
  color: ${colors.green};
  background: ${colors.greenLight};
  border-color: ${colors.greenLight};
`;

const InverseNegativeIndicator = styled(Indicator)`
  color: ${colors.red.primary};
  background: ${colors.red.light};
  border-color: ${colors.red.light};
`;

const NotificationDot = styled('span')`
  top: -7px;
  right: -5px;
  position: relative;
  line-height: inherit;
  &::after {
    content: ' ';
    border-radius: 50%;
    background: ${colors.yellow.secondary};
    border: 2px solid ${colors.yellow.darkest};
    display: inline-block;
    position: relative;
    width: 6px;
    height: 6px;
    margin-left: -9px;
    box-shadow: 0 1px 1px 0 ${colors.grey.primary};
  }
`;

class NoticeNotificationDot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notice: false,
    };
  }

  componentDidMount() {
    const { noticeRequest } = this.props;

    noticeRequest().then((hasNotice) => {
      if (typeof hasNotice !== 'boolean') {
         
        console.warn('notice request did not resolve to boolean', hasNotice);
      }

      this.setState({ notice: hasNotice });
    });
  }

  render() {
    const { notice } = this.state;

    return notice ? <NotificationDot /> : null;
  }
}

NoticeNotificationDot.propTypes = {
  noticeRequest: PropTypes.func.isRequired,
};

export {
  Indicator,
  PositiveIndicator,
  NegativeIndicator,
  NoticeIndicator,
  ProgressIndicator,
  InversePositiveIndicator,
  InverseNegativeIndicator,
  NotificationDot,
  NoticeNotificationDot,
};
